import { render, staticRenderFns } from "./MpuertolocalGrid.vue?vue&type=template&id=196ceb20"
import script from "./MpuertolocalGrid.vue?vue&type=script&lang=js"
export * from "./MpuertolocalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports